import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import airportData from "./data.json";
import faresData from "./fares.json";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import AirlineSeatReclineExtraIcon from "@material-ui/icons/AirlineSeatReclineExtra";
import OndemandVideoIcon from "@material-ui/icons/OndemandVideo";
import WifiIcon from "@material-ui/icons/Wifi";
import WifiOffIcon from "@material-ui/icons/WifiOff";
import CloseIcon from "@material-ui/icons/Close";

const Accordion = withStyles({
  root: {
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {},
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export default function SegmentDetail(props) {
  const [extraInfo, setExtraInfo] = useState(null);
  const [loadingExtraInfo, setLoadingExtraInfo] = useState(false);

  // useEffect(()=>{
  //     getExtraInfo()
  // },[])

  const getDateDifference = (d1, d2) => {
    //d1 > d2
    let a = moment(d1.split(".")[0]);
    let b = moment(d2.split(".")[0]);

    let min = a.diff(b, "minutes");
    let hr = a.diff(b, "hours");
    return hr + "h " + (min - hr * 60) + "m";
  };

  const getExtraInfo = async () => {
    setLoadingExtraInfo(true);
    let body = {
      query:
        "query FlightDetailQuery(\n  $carrier: ID!\n  $code: String!\n  $outboundDepartureDate: DateTime!\n  $source: ID!\n  $destination: ID!\n  $cabinClass: CabinClassType!\n) {\n  seatInfo(carrier: $carrier, code: $code, outboundDepartureDate: $outboundDepartureDate, source: $source, destination: $destination, cabinClass: $cabinClass) {\n    __typename\n    ... on AppError {\n      error: message\n    }\n    ... on SeatInfo {\n      pitch {\n        value\n        unit\n      }\n      width {\n        value\n        unit\n      }\n      recline {\n        value\n        unit\n      }\n      hasWifi\n      powerAvailable\n      audioVideoAvailable\n    }\n  }\n}\n",
      variables: {
        carrier: segment.operating_carrier
          ? segment.operating_carrier
          : segment.airline,
        code: segment.flight_no + "",
        outboundDepartureDate: segment.utc_departure.split(".")[0],
        source: segment.flyFrom,
        destination: segment.flyTo,
        cabinClass: faresData[segment.fare_category].toUpperCase(),
      },
    };
    let response = await axios.post(
      "https://api.skypicker.com/umbrella/v2/graphql?featureName=FlightDetailQuery",
      body
    );
    if (response && response.data && response.data.data) {
      setExtraInfo(response.data.data.seatInfo);
    }
    setLoadingExtraInfo(false);
  };

  const { segment, index, segments } = props;
  segment.utc_departure = segment.utc_departure.replaceAll("/", "-");
  segment.utc_arrival = segment.utc_arrival.replaceAll("/", "-");
  segment.local_departure = segment.local_departure.replaceAll("/", "-");
  segment.local_arrival = segment.local_arrival.replaceAll("/", "-");

  return (
    <div className="segment-light">
      {index > 0 && (
        <Typography
          style={{
            padding: "6px",
            borderRadius: "4px",
            marginRight: "15px",
            marginBottom: "15px",
            color: props.dark ? "var(--black)" : "var(--darker)",
          }}
          component="span"
        >
          {`${getDateDifference(
            segment.utc_departure,
            segments[index - 1].utc_arrival
          )} Layover at ${
            (segment.cityFrom || "") + " (" + segment.flyFrom + ")"
          }`}
          {(segment.is_self_transfer || segment.vi_connection) && (
            <>
              <br></br>&nbsp;&nbsp;You must collect and recheck your baggage
              <br></br>&nbsp;&nbsp;
              {`Self transfer at ${
                segment.cityFrom + " (" + segment.flyFrom + ")"
              }`}
            </>
          )}
        </Typography>
      )}
      <Grid item xs="12">
        <Grid container>
          <Grid item xs="2" sm="1">
            <div
              class="jsx-42120747 circle"
              style={{
                boxSizing: "content-box",
                position: "relative",
                top: "10px",
                flexShrink: "0",
                width: "12px",
                height: "12px",
                borderRadius: "12px",
                marginLeft: "16px",
                marginRight: "32px",
                border: "2px solid #ABABB4",
              }}
            ></div>
          </Grid>
          <Grid item xs="10" sm="11">
            <Typography
              component="span"
              style={{
                fontWeight: "bold",
                color: props.dark ? "var(--black)" : "var(--darker)",
              }}
            >
              {moment(segment.local_departure.split(".")[0]).format("llll")}
            </Typography>
            <Typography
              component="span"
              style={{
                fontSize: "15px",
                color: props.dark ? "var(--black)" : "var(--darker)",
              }}
            >
              {"   Depart at " +
                (segment.cityFrom || "") +
                "(" +
                segment.flyFrom +
                ")"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs="12">
        <Grid container>
          <Grid item xs="2" sm="1">
            <div
              style={{
                content: "",
                width: "4px",
                height: "100%",
                backgroundImage:
                  "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAADwCAMAAAD8WVBVAAAAb1BMVEUAAAC/v8+/v9+/v9e/w9u/wtm/wty/xdrBxt2/xNi/xNvBxdu/w9m/w9vBxNu/w9q/w9zAxNzAxdy/wtm/wtrAw9zAxdvAxdy/xNnAxNvAxNrAxNvAxN3AxNrAxNzAxdzAw9vAw9zAxNvAxNzAxNtGKypvAAAAJHRSTlMAEBAgQFBQYG9wcH+AgI+QkJ+foKCvr6+wv8/Pz9/f3+/v7+9leMSZAAABiklEQVR4Ae3bW5LTMBBG4XakJIwxYRIuIITMhX//ayS8ApWJLp6uqTrfBk61rDe3DAAAAAAAAAAAAAC2Mu3nSy66KunjEqdnqr5O+kuag20tJv1Xii7ZP9a9bSUk3XQOtolXP/SE9WjjTSfd4TS+m3WXHGyosOpOa/DpSutk42RVyOPKJ1U52SBHVXoY+oEr/Aw2wlnVkg1wUINo/VbJZeQo+YycJJeRgxpN1mdWo8XnpLvPeif5nHVUs731WNTswXp8ULOLz92SvliPombfrIc6vPgwYcKECRMmTJgwYcKECRMmTJgwYcKECRMmTJgwYcKECRP2/3H9Vc2S9XinZp/7N248dm4Oahb9V24cl4waLB0bNz5nHfxX5xyWBR1GLtYvNm+ROYx8thHCL1UqwYaYVelogzyqylsbZZdVIds4u9L/gduE4tK9Crn/yUCjx/571ehY9ITvs20ivNdNKdhWDuVGNno9LdtamNM/1TfP9ZAvLp9S0VXJl/mwWRUAAAAAAAAAAAAAfgPrRYYX/D3mLQAAAABJRU5ErkJggg==)",
                backgroundPosition: "center center",
                backgroundRepeat: "repeat-y",
                backgroundSize: "contain",
                marginLeft: "22px",
                marginTop: "3px",
              }}
            ></div>
          </Grid>
          <Grid
            item
            xs="10"
            sm="11"
            style={{ paddingTop: "20px", paddingBottom: "20px" }}
          >
            <Typography
              component="span"
              style={{ color: props.dark ? "var(--black)" : "var(--darker)" }}
            >
              {"Flight duration: " +
                getDateDifference(segment.utc_arrival, segment.utc_departure)}
            </Typography>

            {loadingExtraInfo && (
              <>
                &nbsp;&nbsp;
                <CircularProgress size="15px" />
              </>
            )}
            {props.show_extra_info && extraInfo && !loadingExtraInfo && (
              <div style={{ margin: 5 }}>
                <div className="flight-service">
                  <Typography
                    component="p"
                    style={{
                      fontSize: "12px",
                      color: props.dark ? "var(--black)" : "var(--darker)",
                    }}
                  >
                    <AirlineSeatReclineExtraIcon style={{ fontSize: "20px" }} />{" "}
                    {"Seat Pitch: " +
                      extraInfo?.pitch?.value +
                      extraInfo?.pitch?.unit.toLowerCase()}
                  </Typography>
                </div>
                <div className="flight-service">
                  <Typography
                    component="p"
                    style={{
                      fontSize: "12px",
                      color: props.dark ? "var(--black)" : "var(--darker)",
                    }}
                  >
                    <AirlineSeatReclineExtraIcon style={{ fontSize: "20px" }} />{" "}
                    {"Seat Width: " +
                      extraInfo?.width?.value +
                      extraInfo?.width?.unit.toLowerCase()}
                  </Typography>
                </div>
                <div className="flight-service">
                  <Typography
                    component="p"
                    style={{
                      fontSize: "12px",
                      color: props.dark ? "var(--black)" : "var(--darker)",
                    }}
                  >
                    <AirlineSeatReclineExtraIcon style={{ fontSize: "20px" }} />{" "}
                    {"Seat Recline: " +
                      extraInfo?.recline?.value +
                      extraInfo?.recline?.unit.toLowerCase()}
                  </Typography>
                </div>
                <div className="flight-service">
                  <Typography
                    component="p"
                    style={{
                      fontSize: "12px",
                      color: props.dark ? "var(--black)" : "var(--darker)",
                    }}
                  >
                    {extraInfo?.audioVideoAvailable ? (
                      <OndemandVideoIcon style={{ fontSize: "20px" }} />
                    ) : (
                      <CloseIcon style={{ fontSize: "20px" }} />
                    )}{" "}
                    &nbsp; Audio &amp; Video on demand
                  </Typography>
                </div>
                <div className="flight-service">
                  <Typography
                    component="p"
                    style={{
                      fontSize: "12px",
                      color: props.dark ? "var(--black)" : "var(--darker)",
                    }}
                  >
                    {extraInfo?.hasWifi ? (
                      <WifiIcon style={{ fontSize: "20px" }} />
                    ) : (
                      <WifiOffIcon style={{ fontSize: "20px" }} />
                    )}
                    &nbsp;{`Wi-Fi on Board`}
                  </Typography>
                </div>
              </div>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs="12">
        <Grid container>
          <Grid item xs="2" sm="1">
            <div
              class="jsx-42120747 circle"
              style={{
                boxSizing: "content-box",
                position: "relative",
                top: "9px",
                flexShrink: "0",
                width: "12px",
                height: "12px",
                borderRadius: "12px",
                marginLeft: "16px",
                marginRight: "32px",
                border: "2px solid #ABABB4",
              }}
            ></div>
          </Grid>
          <Grid item xs="10" sm="11">
            <Typography
              component="span"
              style={{
                fontWeight: "bold",
                color: props.dark ? "var(--black)" : "var(--darker)",
              }}
            >
              {moment(segment.local_arrival.split(".")[0]).format("llll")}
            </Typography>
            <Typography
              component="span"
              style={{
                fontSize: "15px",
                color: props.dark ? "var(--black)" : "var(--darker)",
              }}
            >
              {"   Arrive at " +
                (segment.cityTo || "") +
                "(" +
                segment.flyTo +
                ")"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs="12" style={{ marginBottom: "25px" }}>
        <Grid container>
          <Grid item xs="2" sm="1"></Grid>
          <Grid item xs="10" sm="11">
            <Typography
              component="span"
              style={{
                fontSize: "14px",
                color: props.dark ? "var(--black)" : "var(--darker)",
              }}
            >
              {faresData[segment.fare_category]}
            </Typography>
            &nbsp;&nbsp;&nbsp;
            <Typography
              component="span"
              style={{
                fontSize: "14px",
                color: props.dark ? "var(--black)" : "var(--darker)",
              }}
            >
              {"Operated By " +
                airportData[
                  segment.operating_carrier
                    ? segment.operating_carrier
                    : segment.airline
                ]?.name}
            </Typography>
            &nbsp;&nbsp;&nbsp;
            <Typography
              component="span"
              style={{
                fontSize: "14px",
                color: props.dark ? "var(--black)" : "var(--darker)",
              }}
            >
              {"Flight no " + segment.flight_no}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

SegmentDetail.defaultProps = {
  show_extra_info: true,
};
